import axios from 'axios';
import { useEffect, useState } from 'react';

export default function useRegister() {
  const [form, setForm] = useState({
    is_company: 1,
    full_name: '',
  });
  const [isSuccess, setIsSuccess] = useState(null);
  const [formError, setFormError] = useState({});
  const [isDisabledBtn, setIsDisabledBtn] = useState(false);

  const handlerForm = (value, id) => {
    form[id] = value;
    setForm({ ...form });
  };

  const checkInputs = (value, rules, id, name) => {
    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i];
      const [min, length] = rule.split(':');
      if (
        rule === 'required' &&
        (value === null || value === undefined || value.trim() === '')
      ) {
        formError[id] = {
          isError: 1,
          message: `${name} không được bỏ trống.`,
        };
        setFormError({ ...formError });
        return;
      }
      if (rule === 'email') {
        const re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9]+([a-zA-Z\-0-9])?[a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(value)) {
          formError[id] = {
            isError: 1,
            message: `Email không hợp lệ.`,
          };
          setFormError({ ...formError });
          return;
        }
      }
      if (min === 'min' && value.length < Math.abs(length)) {
        formError[id] = {
          isError: 1,
          message: `${name} quá ngắn`,
        };
        setFormError({ ...formError });
        return;
      }
    }
    formError[id] = {
      isError: 2,
    };
    setFormError({ ...formError });
    return;
  };

  useEffect(() => {
    const errorLists = Object.values(formError);
    if (
      (form.is_company === 0 && errorLists.length === 4) ||
      (form.is_company === 1 && errorLists.length === 5)
    ) {
      for (let i = 0; i < errorLists.length; i++) {
        const { isError } = errorLists[i];
        if (isError === 1) {
          setIsDisabledBtn(false);
          break;
        }
        setIsDisabledBtn(true);
      }
    }
  }, [formError]);

  const handlerChooseOption = (value) => {
    setForm({ is_company: value, full_name: '' });
    setFormError({});
    setIsDisabledBtn(false);
  };

  const handlerFormRegister = (e) => {
    e.preventDefault();
    axios
      .post('/api/v1/register', { ...form })
      .then(({ data }) => {
        if (data.success) {
          setForm({ is_company: form.is_company, full_name: '' });
          setFormError({});
          setIsDisabledBtn(false);
          window.location.href = '/dang-nhap';
        } else {
          setIsSuccess(false);
        }
      })
      .catch(() => {
        setIsSuccess(false);
      });
  };
  return {
    handlerChooseOption,
    handlerFormRegister,
    form,
    handlerForm,
    checkInputs,
    isSuccess,
    isDisabledBtn,
    formError,
  };
}
